import * as ambassadorWixIdentityInvitesV1AccountInvite from './identity-invites-v1-account-invite-account-invites.http.js';
import * as ambassadorWixIdentityInvitesV1AccountInviteTypes from './identity-invites-v1-account-invite-account-invites.types.js';
import * as ambassadorWixIdentityInvitesV1AccountInviteUniversalTypes from './identity-invites-v1-account-invite-account-invites.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createInvite(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixIdentityInvitesV1AccountInviteUniversalTypes.CreateInviteRequest,
  ambassadorWixIdentityInvitesV1AccountInviteTypes.CreateInviteRequest,
  ambassadorWixIdentityInvitesV1AccountInviteUniversalTypes.CreateInviteResponse,
  ambassadorWixIdentityInvitesV1AccountInviteTypes.CreateInviteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixIdentityInvitesV1AccountInvite.createInvite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/account-invite/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AccountInvite as AccountInviteOriginal,
  InviteStatus as InviteStatusOriginal,
  InviteStatusWithLiterals as InviteStatusWithLiteralsOriginal,
  InviteResourceAssignment as InviteResourceAssignmentOriginal,
  InviteAssignment as InviteAssignmentOriginal,
  FullNameResource as FullNameResourceOriginal,
  FullNameResourceResourceContextOneOf as FullNameResourceResourceContextOneOfOriginal,
  SiteResourceContext as SiteResourceContextOriginal,
  AccountResourceContext as AccountResourceContextOriginal,
  OrganizationResourceContext as OrganizationResourceContextOriginal,
  Resource as ResourceOriginal,
  PolicyCondition as PolicyConditionOriginal,
  ConditionType as ConditionTypeOriginal,
  ConditionTypeOfOneOf as ConditionTypeOfOneOfOriginal,
  SimpleCondition as SimpleConditionOriginal,
  SimpleConditionValue as SimpleConditionValueOriginal,
  SimpleConditionValueValueOneOf as SimpleConditionValueValueOneOfOriginal,
  SimpleConditionOperator as SimpleConditionOperatorOriginal,
  SimpleConditionOperatorWithLiterals as SimpleConditionOperatorWithLiteralsOriginal,
  JoinedCondition as JoinedConditionOriginal,
  JoinedConditionOperator as JoinedConditionOperatorOriginal,
  JoinedConditionOperatorWithLiterals as JoinedConditionOperatorWithLiteralsOriginal,
  EnvironmentCondition as EnvironmentConditionOriginal,
  EnvironmentConditionConditionOneOf as EnvironmentConditionConditionOneOfOriginal,
  ExperimentCondition as ExperimentConditionOriginal,
  Condition as ConditionOriginal,
  ConditionOperator as ConditionOperatorOriginal,
  ConditionOperatorOperatorsOneOf as ConditionOperatorOperatorsOneOfOriginal,
  EqualOperator as EqualOperatorOriginal,
  ConditionValue as ConditionValueOriginal,
  ConditionValueValueOneOf as ConditionValueValueOneOfOriginal,
  LikeOperator as LikeOperatorOriginal,
  ExperimentOperator as ExperimentOperatorOriginal,
  DependOnOperator as DependOnOperatorOriginal,
  Subject as SubjectOriginal,
  SubjectType as SubjectTypeOriginal,
  SubjectTypeWithLiterals as SubjectTypeWithLiteralsOriginal,
  SubjectContext as SubjectContextOriginal,
  SubjectContextType as SubjectContextTypeOriginal,
  SubjectContextTypeWithLiterals as SubjectContextTypeWithLiteralsOriginal,
  GetAccountInvitesRequest as GetAccountInvitesRequestOriginal,
  GetAccountInvitesResponse as GetAccountInvitesResponseOriginal,
  GetAccountInviteRequest as GetAccountInviteRequestOriginal,
  GetAccountInviteResponse as GetAccountInviteResponseOriginal,
  AccountInviteRequest as AccountInviteRequestOriginal,
  AccountInviteResponse as AccountInviteResponseOriginal,
  CreateInviteRequest as CreateInviteRequestOriginal,
  SubjectInviteAssignments as SubjectInviteAssignmentsOriginal,
  CreateInviteResponse as CreateInviteResponseOriginal,
  InviteFailure as InviteFailureOriginal,
  BulkAccountInviteRequest as BulkAccountInviteRequestOriginal,
  BulkAccountInviteResponse as BulkAccountInviteResponseOriginal,
  ResendAccountInviteRequest as ResendAccountInviteRequestOriginal,
  AcceptAccountInviteRequest as AcceptAccountInviteRequestOriginal,
  AcceptAccountInviteResponse as AcceptAccountInviteResponseOriginal,
  RevokeAccountInviteRequest as RevokeAccountInviteRequestOriginal,
  RevokeAccountInviteResponse as RevokeAccountInviteResponseOriginal,
  UpdateAccountInviteRequest as UpdateAccountInviteRequestOriginal,
  UpdateAccountInviteResponse as UpdateAccountInviteResponseOriginal,
  UpdateAccountInviteAssignmentsRequest as UpdateAccountInviteAssignmentsRequestOriginal,
  UpdateAccountInviteAssignmentsResponse as UpdateAccountInviteAssignmentsResponseOriginal,
  ParseAccountInviteTokenRequest as ParseAccountInviteTokenRequestOriginal,
  ParseAccountInviteTokenResponse as ParseAccountInviteTokenResponseOriginal,
} from './identity-invites-v1-account-invite-account-invites.types.js';
